export default {
  cities: [],
  city: {}
}



// WEBPACK FOOTER //
// ./src/components/city/store/state.js